import React from 'react';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import common_en from './translations/en/common';
import common_he from './translations/he/common';
import common_ru from './translations/ru/common';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: common_en
      },
      he: {
        translation: common_he
      },
      ru: {
        translation: common_ru
      }
    },
    lng: 'en',
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
